export default {
  defaultDisplayName: 'New virtual signal',
};
